export * from './IconHorizonFolderOrange';
